import React from 'react'
import { RacePageDataTransferObject } from '@mobi/api-types'
import { Grid, GridCell } from '@mobi/component-library/Legacy/Grid'
import * as amplify from '@core/Areas/RaceCard/Components/RaceCardContent/Components/LegacyKnockout/ViewModels/AppUtils/Framework/Messaging/EventAggregator'
import { setSelectedProposition } from '@core/Areas/RaceCard/Store'
import { BettingDrawer } from '@core/Components/BettingDrawer'
import { ExpandablePanel } from '@core/Components/ExpandablePanel'
import {
  ExpandablePanelHeaderStyled,
  ExpandablePanelTitleStyled,
  IconStyled,
} from '@core/Components/ExpandablePanel/ExpandablePanel.styles'
import { ExpandablePanelThemes } from '@core/Components/ExpandablePanel/themes'
import { createRaceObjectFromResponse } from '@core/Data/Racing'
import { useAppDispatch } from '@core/Store/hooks'
import { useObservableImmutable } from '@core/Utils/hooks'
import { MysteryQuickPicks } from './Components/MysteryQuickPick'
import { MysteryContainerStyled } from './Mystery.styles'
import {
  ClearRaceBettingPageMysterySelection,
  RaceBettingPageMysterySelection,
  mysteryRaceBettingPageWrapperState$,
} from './MysteryRaceBettingPageWrapperDriver'
import { betFromRaceBettingPageQuickPick } from './utils'

export const MysteryQuickPicksRaceBettingPageWrapper: React.FC<{
  meetingInformation: RacePageDataTransferObject['MeetingInformation']
}> = ({ meetingInformation }) => {
  const [isPanelExpanded, setPanelExpanded] = React.useState(true)
  const dispatch = useAppDispatch()

  const { selectedKey } = useObservableImmutable(mysteryRaceBettingPageWrapperState$, [
    'selectedKey',
  ])

  React.useEffect(() => {
    if (selectedKey) {
      amplify.publish('clear-all-selections-command')
      dispatch(setSelectedProposition(null))
    }
  }, [selectedKey, dispatch])

  React.useEffect(() => {
    amplify.subscribe('selection-made-command', ClearRaceBettingPageMysterySelection)
    return () => {
      amplify.unsubscribe('selection-made-command', ClearRaceBettingPageMysterySelection)
    }
  }, [])

  const selectionCallback = (key: string) => {
    RaceBettingPageMysterySelection(key)
  }

  const HeaderComponent = customHeader(isPanelExpanded)

  return (
    <>
      <MysteryContainerStyled>
        <ExpandablePanel
          title='Mystery Bet'
          themeName={ExpandablePanelThemes.light}
          deferRenderingContentOnExpand={true}
          headerClicked={() => setPanelExpanded(!isPanelExpanded)}
          expanded={isPanelExpanded}
          dataTidValue='mystery-bet'
          headerComponent={HeaderComponent}
        >
          <MysteryQuickPicks selectedKey={selectedKey} selectionCallback={selectionCallback} />
        </ExpandablePanel>
      </MysteryContainerStyled>

      <BettingDrawer
        open={!!selectedKey}
        handleQuickbetClick={() =>
          betFromRaceBettingPageQuickPick(
            selectedKey,
            createRaceObjectFromResponse(meetingInformation)
          )
        }
        dataTId='mystery-buttons'
      />
    </>
  )
}

const customHeader = (isExpanded: boolean) => {
  return (
    <ExpandablePanelHeaderStyled>
      <Grid>
        <GridCell valign='middle' align='left'>
          <ExpandablePanelTitleStyled>Mystery Bet</ExpandablePanelTitleStyled>
        </GridCell>
        <GridCell width='1.5rem' valign='middle'>
          <IconStyled type={isExpanded ? 'arrowup' : 'arrowdown'} size='1.2rem' />
        </GridCell>
      </Grid>
    </ExpandablePanelHeaderStyled>
  )
}
